import { ItemGroupCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/item_group_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type ItemGroupCreatedDetailProps = {
  event: ItemGroupCreatedEvent;
};

export const ItemGroupCreatedDetail = ({
  event,
}: ItemGroupCreatedDetailProps) => {
  const itemGroup = event.itemGroup;

  if (!itemGroup) {
    return (
      <Col className="@ItemGroupCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@ItemGroupCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Item Group Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={itemGroup.id?.value} />
          <FieldDisplay label="Name" value={itemGroup.name} />
          <FieldDisplay label="Number" value={itemGroup.number} />
          <IDField label="Parent ID" value={itemGroup.parentId?.value} />
          <FieldDisplay label="Description" value={itemGroup.description} />
          <FieldDisplay label="Notes" value={itemGroup.notes} />
        </div>
      </Col>
    </Col>
  );
};
